<template>
  <div class="page-container">
    <!--内容-->
    <div class="booksearchCon pt-200">
      <!--面包屑导航-->
      <Breadcrumb :breadcrumbList="['商务阅读平台', 'PDF搜索结果']">
        <div
          class="btn-reset searchcommen bg-primary color-white fs-16 text-center point"
          v-if="!showsearch"
          @click="showsearchbtn"
        >
          搜索
        </div>
      </Breadcrumb>
      <!--图书分类-->
      <div
        class="classification flex ai-center mt-80"
        v-if="showsearch && bookclass.length"
      >
        <span class="ml-30 mr-20 fs-16 color-fontcol3">图书分类 :</span>
        <div class="licon flex ai-center">
          <li
            class="ml-20 mr-20 fs-16 flex ai-center jc-center point"
            v-for="(item, index) in bookclass"
            :class="choselistid == item.id ? 'color-primary' : 'color-fontcol9'"
            :key="index"
            @click="addchose(index, item.id)"
          >
            {{ item.name }}
          </li>
        </div>
      </div>
      <!--图书筛选-->
      <div class="screencon flex ai-center" v-if="showsearch">
        <span class="fs-16 color-fontcol3 ml-30">图书名称 :</span>
        <input class="ml-20 fs-16" type="text" :value="bookname" @input="watchbookname" />
        <span class="fs-16 color-fontcol3 ml-60">书号/ISBN :</span>
        <input class="ml-20 fs-16" type="text" :value="booknum" @input="watchbooknum" />
        <span class="fs-16 color-fontcol3 ml-60">作者 :</span>
        <input class="ml-20 fs-16" type="text" :value="auctor" @input="watchauctor" />
      </div>
      <div class="screencon flex ai-center" v-if="showsearch">
        <span class="fs-16 color-fontcol3 ml-30">出版年份 :</span>
        <input
          class="ml-20 fs-16"
          type="number"
          min="0"
          :value="year"
          @input="watchyear"
        />
        <span class="fs-16 color-fontcol3 ml-60">定价（元）:</span>
        <input
          class="ml-20 fs-16"
          style="width: 0.5rem"
          type="number"
          min="0"
          :value="price1"
          @input="watchprice1"
        />
        <div class="dline ml-20 mr-20"></div>
        <input
          type="number fs-16"
          style="width: 0.5rem"
          min="0"
          :value="price2"
          @input="watchprice2"
        />
        <button class="btn-search bg-primary ml-95 color-white fs-16" @click="search()">
          搜索
        </button>
        <button class="btn-reset ml-20 color-primary fs-16 bg-white" @click="reset()">
          重置
        </button>
      </div>
      <!--搜索结果title-->
      <div class="resulttit mt-30 flex ai-center">
        <span class="ml-30 fs-16 color-fontcol9"
          >图书检索结果共<span class="color-fontcol3">{{ total }}</span
          >条</span
        >
      </div>
      <!--搜索结果con-->
      <div class="resultcon flex ai-center flex-w pb-50">
        <li
          class="mt-30 mb-50 point flex jc-betweet ai-center pt-20 pb-20 pl-20 pr-20"
          v-for="(item, index) in searchlist"
          :key="index"
          :class="item.bigimg ? 'activetransform' : ''"
          @mouseenter="changemall(index)"
          @mouseleave="changemall(index)"
          @click="toDetail(server + item.pdfUrl)"
        >
          <img class="img" :src="server + item.cover" alt="" />
          <div class="infocon">
            <div class="title text-ellipsis2 color-fontcol21 fs-18">
              {{ item.bookTitle }}
            </div>
            <div class="text-ellipsis color-fontcol9 fs-16 mt-10">
              {{ item.author }}
            </div>
            <div class="text-ellipsis color-fontcol9 fs-16">
              <span>ISBN</span><span class="ml-10">{{ item.isbn }}</span>
            </div>
            <div class="flex jc-betweet mt-40">
              <div class="date flex ai-center">
                <img src="../assets/image/date.png" alt="" />
                <span class="color-fontcol9 fs-16 ml-10">{{ item.publishTime }}</span>
              </div>
              <div class="color-red fs-16">¥{{ item.price }}</div>
            </div>
          </div>
        </li>
      </div>
      <!--分页-->
      <div class="pagination mt-10 pb-50 flex jc-center ai-center">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          layout="prev, pager, next, jumper"
          :total="total"
          :page-size="Number(9)"
          hide-on-single-page
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../components/common/breadcrumb";
export default {
  name: "booksearch",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      server: "http://www.cctpress.com/file/",
      keyword: "", //搜素关键词
      choselistid: "", //选择的分类id
      bookclass: [], //图书分类
      bookname: "", //图书名称
      booknum: "", //图书书号
      auctor: "", //作者
      year: "", //出版年份
      price1: "", //最小价格
      price2: "", //最大价格
      searchlist: [],
      currentPage: 1, //默认当前页为第一页
      total: 0, //总页数
      showsearch: true, //是否显示搜索条件
    };
  },
  mounted() {
    //监听屏幕滚动
    window.addEventListener("scroll", this.scrollToTop);
    this.getnavs();
    if (this.$route.query.id) {
      this.choselistid = this.$route.query.id;
    }
    this.search();
  },
  methods: {
    //查询图书分类
    async getnavs() {
      var res = await this.$API.API_Ajax("侧面导航列表", {
        type: this.CONSTANT.getDateByCode("reading_id").id,
      });
      if (res.code == 200) {
        this.bookclass = res.data;
      }
    },
    //监听图书名称
    watchbookname(e) {
      this.bookname = e.currentTarget.value;
    },
    //监听图书书号
    watchbooknum(e) {
      this.booknum = e.currentTarget.value;
    },
    //监听作者
    watchauctor(e) {
      this.auctor = e.currentTarget.value;
    },
    //监听年份
    watchyear(e) {
      var val = e.currentTarget.value;
      this.year = val >= 0 ? val : 0;
    },
    //监听价格1
    watchprice1(e) {
      var val = e.currentTarget.value;
      this.price1 = val >= 0 ? val : 0;
    },
    //监听价格2
    watchprice2(e) {
      var val = e.currentTarget.value;
      this.price2 = val >= 0 ? val : 0;
    },
    //查询
    async search() {
      var params = {
        columnId: this.choselistid,
        title: this.bookname,
        isbn: this.booknum,
        author: this.auctor,
        publishTime: this.year,
        minPrice: this.price1,
        maxPrice: this.price2,
        pageNum: this.currentPage,
        pageSize: "9",
      };
      var res = await this.$API.API_Ajax("PDF文档检索", params);
      if (res.code == 200) {
        var list = res.data.list;
        list.map((item, index) => {
          item.bigimg = false;
        });
        this.searchlist = list;
        this.total = res.data.total;
         //查询成功后回到顶部
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    },
    //重置
    reset() {
      this.choselistname = "";
      this.choselistid = "";
      this.bookname = "";
      this.booknum = "";
      this.auctor = "";
      this.year = "";
      this.price1 = "";
      this.price2 = "";
    },
    changemall(index) {
      this.searchlist[index].bigimg = !this.searchlist[index].bigimg;
    },
    //监听屏幕高度
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.searchlist.length > 3) {
        if (scrollTop > 0) {
          this.showsearch = false;
        } else {
          this.showsearch = true;
        }
      }
    },
    //显示搜索
    showsearchbtn() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.showsearch = true;
    },
    //添加选择
    addchose(index, id) {
      this.choselistid = id;
      this.search();
    },
    //删除选择
    closechose(index) {
      this.choselistindex = "";
      this.choselistid = "";
    },
    //显示蒙层
    togglebox(index) {
      this.searchlist[index].boxshow = !this.searchlist[index].boxshow;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.search();
    },
    //跳转详情
    toDetail(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  width: 100%;
  height: auto;
  margin: auto;
  .booksearchCon {
    width: 65%;
    height: auto;
    margin: auto;
    .line {
      height: 3px;
    }
    .chosecon {
      min-height: 55px;
      background: #f5f5f5;
      border-bottom: 1px solid #e4e4e4;
      .licon {
        width: 85%;
        height: 100%;
        li {
          min-width: 60px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #3b8ce0;
          position: relative;
          img {
            width: 12px;
            height: 12px;
          }
        }
      }
    }
    .classification {
      height: 60px;
      border-bottom: 1px solid #e4e4e4;
    }
    .screencon {
      height: 60px;
      border-bottom: 1px solid #e4e4e4;
      input {
        width: 200px;
        height: 30px;
        line-height: 35px;
        border: 1px solid #dadada;
        padding: 0 5px;
      }
      .dline {
        width: 20px;
        height: 2px;
        background: rgba(218, 218, 218, 1);
      }
    }
    .resulttit {
      height: 55px;
      background: #f5f5f5;
    }
    .resultcon {
      li {
        width: 370px;
        height: 225px;
        position: relative;
        .img {
          width: 156px;
          height: 221px;
          // border:6px solid #fff;
          box-shadow: 0px 4px 9px 1px rgba(47, 48, 48, 0.1);
        }
        .infocon {
          width: 191px;
          height: 175px;
          .title {
            width: 100%;
            height: 49px;
            line-height: 27px;
          }
          .date {
            img {
              width: 17px;
              height: 17px;
            }
          }
        }
        .othercon {
          position: absolute;
          bottom: 0;
          left: 0;
          transition: height 0.8s;
          width: 370px;
          // height: 225px;
          background: #a3cefc;
          border-radius: 5px;
          .left {
            width: 50%;
            height: 100%;
            .tit {
              width: 80%;
              margin: auto;
            }
            .bth {
              width: 75px;
              height: 33px;
              border-radius: 20px;
            }
          }
          .right {
            width: 50%;
            height: 100%;
            img {
              width: 75%;
              height: 80%;
              border-radius: 10px;
              transform: rotate(7deg);
              -ms-transform: rotate(7deg); /* IE 9 */
              -webkit-transform: rotate(7deg); /* Safari and Chrome */
            }
            .active {
              transform: rotate(-7deg);
              -ms-transform: rotate(-7deg); /* IE 9 */
              -webkit-transform: rotate(-7deg); /* Safari and Chrome */
              transition: 1s;
            }
          }
        }
      }
    }
    .pagination {
      .btn {
        width: 60px;
        height: 24px;
      }
    }
  }
}
</style>
